const axios = require('axios').default;
const qs = require('qs');
class Request {
    //axios请求
    postRequest(strUrl, fun, data) {
        //qs模块转义数据格式
        data = qs.stringify(data);
        //发送post请求
        axios.post(strUrl, data).then(function (result) {
            fun(result.data);
        })
    }
    //二维码请求接口
    qeCodepostRequest(strUrl, fun, data) {
        //qs模块转义数据格式
        data = qs.stringify(data);
        //发送post请求
        axios.post(strUrl, data, {
            responseType: 'blob',
            emulateJSON: true
        }).then(function (result) {
            fun(result.data);
        })
    }
    //封装导出接口
    export(urlAnfData) {
        window.location.href = urlAnfData;
    }
    //文件上传
    postFileRequest(strUrl, fun, data) {
        //设置文件上传发送请求头（文件上传不需要qs转义)
        let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
        };
        //发送post请求
        axios.post(strUrl, data, config).then(function (result) {
            fun(result.data);
        })
    }
}
let request = new Request();
export default request